import React, { useState, useEffect, useRef } from 'react';
import {
    Button,
    Col,
    ButtonGroup,
    ModalV2,
    ModalV2Content,
    ModalV2Footer,
    ModalV2Title,
    Row,
} from '@si-armes/dsfr-react';
import PropTypes from 'prop-types';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useDispatch, useSelector } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import { FormProvider, useForm } from 'react-hook-form';
import {
    MOTIF_DEMANDE_PIECES_JOINTES,
    TITRES_PIECES_JOINTES,
    TRANSITION_COMPLETER_PJ,
} from 'constants/titreDetention.constants';
import { getArrayFilesToSend } from 'utils/fileFunction';
import FileUploadeFront from 'components/Commun/Form/InputFiles/Model/FileUploadeFront';
import {
    API_TRANSITION_TITRE_DETENTION,
    CONTEXT_MODIFIER_TITRE_DETENTION,
    API_GET_MES_DEMARCHES_EN_COURS,
    CONTEXT_MES_DEMARCHES_EN_COURS,
} from 'constants/apiUrls.constants';

const ModalePiecesJointesTitreDetention = ({ titreDetention, fermerModale }) => {
    const dispatch = useDispatch();
    const [activerBoutonValider, setActiverBoutonValider] = useState(false);
    const { uuid, typeTitreDetention, piecesJointesManquantes } = titreDetention;
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { handleSubmit, formState, getValues } = hookForm;

    const getData = async () => {
        const data = await Promise.all(
            Object.entries(getValues('pieceJointes')).map(async ([type, pieceJointe]) => {
                const fichiers = await getArrayFilesToSend(
                    pieceJointe.fichiers
                        ? pieceJointe.fichiers.filter(
                              (fichier) => fichier instanceof FileUploadeFront,
                          )
                        : [],
                );
                return {
                    type,
                    fichiers,
                };
            }),
        );

        return data.filter(({ fichiers }) => fichiers.length > 0);
    };

    useEffect(() => {
        setActiverBoutonValider(false);
        const fetchData = async () => {
            const data = await getData();
            return data;
        };

        fetchData().then((data) => {
            if (data.length === piecesJointesManquantes.length) {
                setActiverBoutonValider(true);
            }
        });
    }, [...piecesJointesManquantes.map(({ type }) => getValues(`pieceJointes.${type}.fichiers`))]);

    const onSubmit = async () => {
        const data = await getData();
        dispatch(
            postAPI(
                usagerClientReducer,
                API_TRANSITION_TITRE_DETENTION.replace(':type', typeTitreDetention)
                    .replace(':uuid', uuid)
                    .replace(':transition', TRANSITION_COMPLETER_PJ),
                { pieceJointes: { ...data } },
                CONTEXT_MODIFIER_TITRE_DETENTION,
            ),
        );
    };
    const { data: titre, isLoading: isLoadingTitreDetentionModifier } = useSelector(
        (state) => state.titreDetention.modifier,
    );

    if (titre) {
        dispatch(reinitialiseAPI(CONTEXT_MODIFIER_TITRE_DETENTION));
        fermerModale();
        // Recharger mes demarches ...
        dispatch(
            getAPI(
                usagerClientReducer,
                API_GET_MES_DEMARCHES_EN_COURS,
                CONTEXT_MES_DEMARCHES_EN_COURS,
            ),
        );
    }

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <ModalV2
            id="modificationPieces"
            idModalTitle="modificationPieces-title"
            size="lg"
            onClose={fermerModale}
            ref={dialog}
        >
            <ModalV2Content>
                <ModalV2Title id="modificationPieces-title">Modification de pièces</ModalV2Title>

                <p>
                    Une ou plusieurs des pièces constituant votre demande d'autorisation
                    d'acquisition et de détention sont illisibles ou invalides. Veuillez cliquer sur
                    "Importer" afin de sélectionner pour chaque élément demandé une pièce lisible et
                    valide. Une fois toutes les pièces importées, veuillez cliquer sur le bouton
                    "Valider"
                </p>
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {piecesJointesManquantes.map(({ type, motif }) => (
                            <Row key={type} className="margin-top-md">
                                <Col col={12}>
                                    <InputFiles
                                        label={`${TITRES_PIECES_JOINTES[type]} (${MOTIF_DEMANDE_PIECES_JOINTES[motif]})`}
                                        name={`pieceJointes.${type}.fichiers`}
                                        error={formState.errors ? formState.errors[type] : null}
                                    />
                                </Col>
                            </Row>
                        ))}
                    </form>
                </FormProvider>
            </ModalV2Content>
            <ModalV2Footer>
                <ButtonGroup align="right" inline>
                    <Button name="retour" onClick={fermerModale}>
                        Retour
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onSubmit}
                        disabled={!activerBoutonValider}
                        isLoading={isLoadingTitreDetentionModifier}
                    >
                        Valider
                    </Button>
                </ButtonGroup>
            </ModalV2Footer>
        </ModalV2>
    );
};

ModalePiecesJointesTitreDetention.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    titreDetention: PropTypes.object,
};

export default ModalePiecesJointesTitreDetention;
